import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import ConfirmDialog from '../Dialog/ConfirmDialog';
import {
  getTripDetailsV3,
  deleteVendorExpense,
  deletePartyPayment,
  paymentCancel
} from "../../../store/actions/tripActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import Slide from '@material-ui/core/Slide';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Button
} from '@material-ui/core';
import * as logger from '../../../logger';

const useStyles = makeStyles((theme) => ({
  info: {
    padding: 24,
    backgroundColor: '#d6def7',
    height: '100%',
    minHeight: 100,
    maxHeight: 100,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    color: '#0033cc',
    alignItems: 'center',
    fontWeight: 300
  },

}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DeletePartyPayment = (props) => {
  const { location, tripId, deleteId, paymentData, deleteOpen, dispatchTripDetailsAction, dispatchDeletePartyPayment, onDeleteSucees, onDeleteNo } = props;
  const classes = useStyles();
  let history = useHistory();
  const [open, setOpen] = React.useState(deleteOpen);
  let confirmMessage = "Are you sure Want to Delete a Party Payment?";
  let confirmTitle = "Delete Party Payment";
  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  const onConfirm = (confirm) => {
    if (confirm) {
      dispatchDeletePartyPayment(tripId, deleteId, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces("Party Payment Deleted Suceessfully!");
          onDeleteSucees()
        } else {
        }
      },
        () => {
        })
    } else {
      onDeleteNo()
      //fetchTrip(tripId) 
    }
  }

  // const handleClose = () => {
  //   setOpen(false);
  //   onDeleteNo();
  // }

  // const handleConfirm = () => {

  //   dispatchCancelPayment(deleteId,
  //     (data) => {
  //       if (data && data.status && data.status.code == 200) {
  //         logger.log("Delete Party Paymnet Dweb", "Cancel Party Payment Successfull");
  //         setOpen(false);
  //         onDeleteSucees();
  //       }
  //     },
  //     () => {
  //       logger.log("Delete Party Paymnet Dweb", "Cancel Party Payment Failed");
  //     }
  //   )

  // }

  return (
    <>
      {open && <ConfirmDialog confirmOpen={open} confirmTitle={confirmTitle} confirmMessage={confirmMessage} onClose={onConfirm} />
      }
      {/* {open &&
        <Dialog
          open={open}
          TransitionComponent={Transition}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          maxWidth="sm"
          classes={{ paperScrollPaper: classes.dialogV1 }}
        >
          <DialogTitle id="alert-dialog-slide-title" className={classes.dialogTitleV1}>{confirmTitle}</DialogTitle>
          <DialogContent>
            {confirmMessage} {paymentData && <span style={{ fontWeight: 'bold', marginLeft: 2 }}>{paymentData}</span>}
          </DialogContent>
          <DialogActions className={classes.dialogActionsV1}>
            <Button onClick={handleClose} className={classes.discardButton}>
              DISCARD
            </Button>
            <Button onClick={handleConfirm} className={classes.removeButton}>
              REMOVE
            </Button>
          </DialogActions>
        </Dialog>
      } */}
    </>
  );
}
DeletePartyPayment.propTypes = {
  tripId: PropTypes.any.isRequired,
};
const DeletePartyPaymentWithRouter = withRouter(DeletePartyPayment);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
  dispatchDeletePartyPayment: (tripId, paymentId, onSuccess, onFailure) => dispatch(deletePartyPayment(
    tripId,
    paymentId,
    null,
    onSuccess,
    onFailure
  )),

});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletePartyPaymentWithRouter);